import React, { useState } from "react";

const DEFAULT_TRUNCATE = 120;

export default function ExpandableText({
	text,
	truncateAt = DEFAULT_TRUNCATE,
	className = "small text-muted",
}) {
	const [expanded, setExpanded] = useState(false);
	if (!text) return null;

	const needsTruncate = text.length > truncateAt;
	const shown = needsTruncate && !expanded ? `${text.slice(0, truncateAt)}…` : text;

	return (
		<div className={className}>
			{shown}
			{needsTruncate && (
				<button
					type="button"
					onClick={() => setExpanded((v) => !v)}
					className="monitoring__analysis-strategy-show-more btn btn-link btn-sm p-0 ms-1"
				>
					{expanded ? "Less" : "More"}
				</button>
			)}
		</div>
	);
}
